module.exports = __webpack_public_path__ + "img/Avatar-86.b71be225.svg";